import axios from 'axios';

export const getBlogs = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}blogs`);
    return response.data;
  } catch (error) {
    console.error('Error fetching blogs:', error.response || error.message);
    throw error;
  }
};
